import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/back-arrow.svg'
import _imports_1 from '@/assets/icons/logout.svg'


const _hoisted_1 = { class: "headline" }
const _hoisted_2 = { class: "headline-content" }
const _hoisted_3 = { class: "title-button" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "back-icon"
}, null, -1)
const _hoisted_5 = { class: "back-button-text" }
const _hoisted_6 = {
  class: "headline-title",
  "data-cy": "headline-title"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_8 = { class: "logout-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/'))),
          class: "back-button",
          "data-cy": "back-to-order"
        }, [
          _hoisted_4,
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.t("COMMON.BACK")), 1)
        ]),
        _createElementVNode("span", _hoisted_6, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ]),
      _createElementVNode("div", {
        class: "logout",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.logoutUser('logout-by-user', true)))
      }, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.t("COMMON.LOGOUT")), 1)
      ])
    ])
  ]))
}